import { render } from "./LoaderComponent.vue?vue&type=template&id=12a22420&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=12a22420&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a22420"]])

export default __exports__